export default {
  general: {
    section: 'Sección',
    loadingTemplate: 'Cargando vista previa de la plantilla...',
    isExternal: 'para Insp. Externas',
    externalInspection: 'Habilitar para inspecciones externas',
    geographic: 'Ubicación Geografica',
    latitude: 'Latitud',
    longitude: 'Longitud',
    brand: 'Marca',
    model: 'Modelo',
    selectWarning: 'Seleccione al menos una inspección',
    damage: 'Daños',
    selectStatus: 'Seleccionar estado',
    finishStatus: 'Finalizado',
    inProgress: 'En progreso',
    repairDate: 'Fecha de reparación',
    noData: 'No se encontraron datos',
    noGallery: 'No se encontro ninguna galería',
    noRegister: 'No se encontraron registros',
    trailer1: 'Datos de remolque 1',
    trailer2: 'Datos de remolque 2',
    downloadReports: 'Descargar reportes',
    fail: 'Falla',
    none: 'Ninguno',
    ownerName: 'Dueño de la unidad',
    seeDetail: 'Ver detalles',
    hideDetail: 'Ocultar detalles',
    selectAll: 'Seleccionar todo',
    changeStatus: 'Cambiar estado',
    success: 'Éxito',
    warn: 'Advertencia',
    error: 'Error',
    view: 'Ver',
    description: 'Descripción',
    image: 'Imagen',
    add: 'Agregar',
    edit: 'Editar',
    close: 'Cerrar',
    return: 'Regresar',
    openAll: 'Abrir todo',
    closeAll: 'Cerrar todo',
    warning: 'Advertencia',
    remove: 'Remover',
    home: 'Inicio',
    subscriptions: 'Suscripciones',
    notifications: 'Notificaciones',
    unitTypes: 'Tipos de unidades',
    unitType: 'Tipo de unidad',
    site: 'Sitio',
    permissions: 'Permisos',
    history: 'Historial',
    historyTotal: 'Historial total de Inspecciones',
    manager: 'Gerente',
    comment: 'Comentario',
    plates: 'Placas',
    plate: 'Placa',
    vin: 'Vin',
    property: 'Propiedad',
    tests: 'Checklists',
    defaultTests: 'Checklists Predeterminados',
    sites: 'Sitios',
    inspections: 'Inspecciones',
    inspection: 'Inspección',
    confirm: 'Confirmación',
    users: 'Usuarios',
    user: 'Usuario',
    accept: 'Aceptar',
    cancel: 'Cancelar',
    name: 'Nombre',
    email: 'Correo electrónico',
    company: 'Empresa',
    companies: 'Empresas',
    lastNames: 'Apellidos',
    licence: 'Licencia',
    role: 'Rol',
    plan: 'Plan',
    units: 'Unidades de transporte',
    unit: 'Unidad de transporte',
    duration: 'Duración',
    expirationDate: 'Fecha de expiración',
    date: 'Fecha',
    dateRange: 'Rango de fecha',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    logoutMessage: '¿Está seguro de que desea cerrar sesión?',
    enter: 'Entrar',
    change: 'Cambiar',
    phone: 'Teléfono',
    search: 'Buscar',
    actions: 'Acciones',
    delete: 'Eliminar',
    save: 'Guardar',
    reloadFile: 'Volver a cargar archivo',
    loadedElements: 'Elementos cargados',
    passwordRule: 'La contraseña debe tener al menos un número, una letra mayúscula, una letra minuscula y un caracter especial. ',
    deleteMessage: '¿Está seguro que desea eliminar este elemento?',
    register: 'Registro',
    pageNotFound: 'Página no encontrada',
    loading: 'Cargando',
    goHome: 'Ir a la página de inicio',
    send: 'Enviar',
    reports: 'Reportes',
    imgFormats: 'Formatos de imagenes permitidas: JPG, JPEG y PNG',
    created: 'Creado',
    contacts: 'Contactos',
    subject: 'Asunto',
    editUser: 'Editar información de usuario',
    editCompany: 'Editar información de la empresa',
    unitNumber: 'Número económico',
    template: 'Plantilla',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    unitMonitoring: 'Monitoreo de unidades',
    damageReport: 'Reporte daños',
    traile: 'Remolque',
    noEco: 'No. Eco',
    noInspection: 'No. Inspección',
    yard: 'Patio',
    damageNotes: 'Notas daño',
    comments: 'Comentarios',
    owne: 'Dueño',
    reportedDamage: 'Daños reportados',
    operat: 'Operador',
    customer: 'Cliente',
    transitType: 'Tipo tránsito',
    loadType: 'Tipo carga',
    origin: 'Origen',
    destination: 'Destino',
    answer: 'Respuesta',
    damageLevel: 'Nivel daños',
    typeInspection: 'Tipo de inspección',
    damages: "Daño",
    incidence: "Incidencia",
    ok: "OK",
    yes: "Si",
    no: "No",
    inspectionDate: "Fecha de inspección",
    checklistName: "Nombre del checklist",
    inspectionYard: "Patio de inspección",
    mechanicalCheck: "Verificación fisicomecanica",
    smokeCheck: "Verificación de humo",
    certification: "Certificación",
    wetMeasurement: "Medida húmeda",
    dryMeasurement: "Medida seca",
    capacity:  "Capacidad",
    typeOperation: "Tipo de operación",
    status: "Estatus",
    approved: "Aprobado",
    refused: "Rechazado",
    pollution: "Contaminación",
    reasonRejection: "Motivo de rechazo",
    typeTransit:"Tipo de tránsito",
    dateLastInspection: "Fecha de la última inspección",
    subscriptionExpirationDate: "Fecha de vencimiento de la suscripción",
    damageInspections: "Daños en inspecciones",
    sitesDamage: "Patios con más daños",
    inspectionClassification: "Clasificación de inspección",
    thereIsNoData: "No hay datos disponibles",
    courtYards: "Patios",
    resetFilter: "Restablecer filtros",
    errorFilterMessage: "Verifique que los filtro cumplan las validaciones",
    inspector: "Inspector",
    inspectores: "Inspectores",
    operators: "Operadores",
    operator: "Operador",
    clients: "Clientes",
    administrators: "Administradores",
    admin: "Administrador",
    credential: "Credencial",
    credentialNumber: "Número de credencial",
    photoCredential: "Foto de la credencial",
    numberLicense: "Numero de licencia",
    photoLicense: "Foto de la licencia",
    vigenteLicense: "vigencia de licencia",
    photoOperator: "Foto del operador",
    updatePhotoCredential: "Actualizar credencial",
    updatePhotoLicense: "Actualizar licencia",
    updatePhotoOperator: "Actualizar foto del operador",
    dataOfThe: "Datos del",
    registeredUnits: "Unidades registradas",
    occurredIncidence : "Incidencias ocurridas",
    unitWithDamage: 'Unidades con daños',
    inspectionsToday: 'Inspecciones del día',
    accepted: 'Aceptado',
    low: 'Bajo',
    medium: 'Moderado',
    high: 'Alto',
    month: 'Mes',
    assignOperatorInspector: 'Asignar operador a inspector',
    assign: 'Asignar',
    pass: 'Cumple',
    doesNotComply: 'No cumple',
    reportsCatalog: 'Catálogo de reportes',
    consulting: 'Consultar',
    clickMessage: 'Da click para visualizar el reporte',
    of: 'de',
    withoutDamage: 'Sin daños',
    withoutData: 'Sin datos',
    quantity: 'Cantidad',
    inspectionPointsDamage: 'Puntos de inspección con daños',
    totalDamages: 'Total daños',
    minorDamage: 'Daños leves',
    moderateDamage: 'Daños moderados',
    highDamage: 'Daños altos',
    damagedOperators: 'Operadores con daños',
    intensityDamage: 'Intensidad de daños',
    frequencyOfDamagePerUnit: 'Frecuencia de daños por unidad',
    units: 'Unidades',
    frequency: 'Frecuencia',
    damagesPerDay: 'Daños por día',
    frequencyOfDamage: 'Frecuencia de daños(%)'
  },
  dashboard: {
    welcome: 'Bienvenido',
    changePassword: 'Cambiar contraseña',
    oldPassword: 'Contraseña anterior',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    userInfo: 'Información de usuario',
    companyInfo: 'Información de la empresa',
    subscription: 'Suscripción',
    planMessage: 'Suscripción contratada por un año',
    passNoMatch: 'Las contraseñas no coinciden',
    inspectionPerformedReport: 'Reporte de inspecciones realizadas por patio del {starDate} al {endDate}',
    damageInspectionsReport: 'Reporte de daños en inspecciones del {starDate} al {endDate}',
  },
  login: {
    forgot: '¿Olvidaste tu contraseña?',
    recover: 'Recuperar contraseña',
    change: 'Cambiar contraseña',
    changeMessage: 'Haz solicitado un cambio de contraseña anterior. Por favor, ingresa la nueva contraseña con la que tendrás acceso a la plataforma.',
    password: 'Contraseña',
    repeatPassword: 'Repetir contraseña',
    newPassword: 'Nueva contraseña',
    recoverMessage: 'Ingresa el correo electrónico con el cual te registraste y nosotros te enviaremos instrucciones para reestablecer tu contraseña.',
    dontMatch: 'Las contraseñas no coinciden',
    signUp: 'Registrarme',
    noAccount: '¿No tienes una cuenta?'
  },
  company: {
    add: 'Agregar empresa',
    delete: 'Eliminar empresa',
    edit: 'Editar empresa',
    delMessage: '¿Está seguro que desea eliminar la empresa ',
    formMessage: 'Ingresa todos los datos correspondientes a la información de la empresa.'
  },
  unitTypes: {
    add: 'Agregar tipo de unidad',
    delete: 'Eliminar tipo de unidad',
    edit: 'Editar tipo de unidad',
    delMessage: '¿Está seguro que desea eliminar el tipo de unidad ',
    formMessage: 'Ingresa todos los datos correspondientes al tipo de unidad.'
  },
  tests: {
    add: 'Agregar checklist',
    edit: 'Editar checklist',
    testValidation: 'Debe haber al menos una sección y una pregunta por sección. Por favor revisa de nuevo.',
    delete: 'Eliminar checklist',
    delMessage: '¿Está seguro que desea eliminar el checklist ',
    formMessage: 'Ingresa todos los datos correspondientes al checklist.',
    sections: 'Secciones',
    questions: 'Preguntas',
    addSection: 'Agregar sección',
    addQuestion: 'Agregar pregunta',
    required: 'Comentario requerido',
    noRequired: 'Comentario no requerido',
    photoRequired: 'Foto requerida',
    photoNoRequired: 'Foto no requerida',
    critic: 'Critico',
    noCritic: 'No critico',
    delQuestion: 'Eliminar pregunta',
    delSection: 'Eliminar sección',
    delSectionMessage: '¿Está seguro que desea eliminar esta sección?',
    noAnswered: 'Hay algunas secciones o preguntas que no han sido completadas. Por favor revisa de nuevo.',
    download: 'Descargar PDF',
    defaultTestMessage: 'Seleccione el país y el sitio al que desea aplicar el checklist predeterminado.',
    templates: {
      security: 'Seguridad',
      platform: 'Plataforma',
      thermal: 'Caja refrigerada',
      trauliner: 'Caja seca'
    },
    defaultCheck: 'Cuestionario predeterminado',
    formatPDF: 'Formato de PDF',
  },
  address: {
    social_reason: 'Razón social',
    tax: 'RFC',
    tax_regimen: 'Régimen fiscal',
    name: 'Dirección',
    street: 'Calle',
    suburb: 'Colonia',
    number: 'Número',
    city: 'Ciudad',
    state: 'Estado',
    country: 'País',
    zip: 'C.P',
    additionalInfo: 'Información adicional',
    timeZone: 'Zona horaria'
  },
  subscriptions: {
    add: 'Agregar suscripción',
    edit: 'Editar suscripción',
    delete: 'Eliminar suscripción',
    delMessage: '¿Está seguro que desea eliminar esta suscripción',
    formMessage: 'Ingresa todos los datos correspondientes a la información de la suscripción.',
  },
  users: {
    add: 'Agregar usuario',
    edit: 'Editar usuario',
    formMessage: 'Ingresa todos los datos correspondientes a la información del usuario.',
    delMessage: '¿Está seguro que desea eliminar este usuario'
  },
  units: {
    add: 'Agregar Unidad de transporte',
    addMultiple: 'Agregar Múltiples Unidades de transporte',
    edit: 'Editar Unidad de transporte',
    noPlates: 'No tiene',
    addPlates: 'Agregar placas',
    removePlate: 'Remover placa',
    editPlate: 'Editar placa',
    formMessage: 'Ingresa todos los datos correspondientes a la información de la Unidad de transporte.',
    multipleFormMessage: 'Descargue la plantilla y rellenela con los datos correspondientes para cargar múltiples unidades de transporte.',
    delMessage: '¿Está seguro que desea eliminar esta Unidad de transporte',
    delPlateMessage: '¿Está seguro que desea eliminar esta placa',
    own: 'Propio',
    external: 'Externo',
    OWN: 'Propio',
    EXTERNAL: 'Externo',
    downloadTemplate: 'Descargar Plantilla',
    ACTIVE: "Activo",
    INACTIVE: "Inactivo",
    IN_GARAGE: "En garaje",
  },
  sites: {
    add: 'Agregar sitio',
    edit: 'Editar sitio',
    formMessage: 'Ingresa todos los datos correspondientes a la información del sitio.',
    addUsers: 'Agregar usuarios al sitio',
    relatedUsers: 'Usuarios relacionados',
    noUsers: 'No hay usuarios registrados',
    delMessage: '¿Está seguro que desea eliminar este sitio',
    delUserMessage: '¿Está seguro que desea eliminar este usuario',
    relationUnit: 'Relación de unidades',
    preview: 'Vista previa',
    typeQuestionnaire: {
      title: 'Tipo de cuestionario',
      security: 'Seguridad',
      maintenance: 'Mantenimiento',
      log: 'Bitácora'
    },
    headers: {
      questionTitle: 'Titulo de la pregunta',
      description: 'Descripción',
      comment: 'Comentario requerido'
    }
  },
  permissions: {
    assign: 'Asignar permisos',
    edit: 'Editar permisos',
    remove: 'Remover permisos',
    rolePermissions: 'Permisos de Rol',
    availablePermissions: 'Permisos Disponibles',
    COMPANIES: 'Empresas',
    DASHBOARD: 'Inicio',
    USERS: 'Usuario',
    SUBSCRIPTIONS: 'Suscripciones',
    NOTIFICATIONS: 'Notificaciones',
    SITES: 'Sitios',
    UNIT_TYPES: 'Tipos de unidades',
    UNITS: 'Unidades de transporte',
    QUESTIONNAIRES:	'Checklists',
    HISTORY:	'Historial',
    INSPECTIONS:	'Inspecciones',
    REPORTS: 'Reportes',
    PERMISSIONS: 'Permisos',
    USER_CREATE: 'Crear Usuarios',
    USER_READ: 'Listar Usuarios',
    USER_UPDATE: 'Actualizar Usuarios',
    USER_DELETE: 'Eliminar Usuarios',
    COMPANY_CREATE: 'Crear Empresas',
    COMPANY_READ_ALL: 'Listar todas las Empresas',
    COMPANY_READ: 'Listar Empresas',
    COMPANY_UPDATE: 'Actualizar Empresas',
    COMPANY_DELETE: 'Eliminar Empresas',
    SITE_CREATE: 'Crear sitios',
    SITE_READ: 'Listar sitios',
    SITE_UPDATE: 'Actualizar sitios',
    SITE_DELETE: 'Eliminar sitios',
    SITES_USER_ADD: 'Agregar Usuarios a sitios',
    SITES_USER_READ_ALL: 'Listar todos los Usuarios de sitios',
    SITES_USER_READ: 'Lista Usuarios de sitios',
    SITES_USER_REMOVE: 'Quitar Usuarios de sitios',
    UNIT_TYPE_CREATE: 'Crear Tipos de Unidades',
    UNIT_TYPE_READ: 'Listar Tipos de Unidades',
    UNIT_TYPE_UPDATE: 'Actualizar Tipos de Unidades',
    UNIT_TYPE_DELETE: 'Eliminar Tipos de Unidades',
    UNIT_CREATE: 'Crear Unidades de transporte',
    UNIT_READ_ALL: 'Listar todas las Unidades de transporte',
    UNIT_READ_ONLY_SITE: 'Listar Unidades de transporte pertenecientes sitios',
    UNIT_UPDATE: 'Actualizar Unidades de transporte',
    UNIT_DELETE: 'Eliminar Unidades de transporte',
    PLATE_CREATE: 'Crear Placas',
    PLATE_READ: 'Listar Placas',
    PLATE_UPDATE: 'Actualizar Placas',
    PLATE_DELETE: 'Eliminar Placas',
    QUESTIONNAIRE_CREATE: 'Crear Checklists',
    QUESTIONNAIRE_UPDATE: 'Actualizar ',
    QUESTIONNAIRE_READ: 'Listar Checklists',
    QUESTIONNAIRE_DELETE: 'Eliminar Checklists',
    QUESTIONNAIRES_DEFAULT_ADD: 'Agregar Checklists Predeterminados',
    INSPECTION_CREATE: 'Crear Inspecciones',
    INSPECTION_FILL: 'Contestar Inspecciones',
    INSPECTION_HISTORY: 'Historial de Inspecciones',
    INSPECTION_READ: 'Listar Inspecciones',
    INSPECTION_REPORT: 'Reportes de Inspecciones',
    INSPECTION_DOWNLOAD: 'Descargar Inspecciones',
    CARD_ADD: 'Agregar Tarjeta',
    CHARGE_ADD: 'Agregar Cargo',
    SUBSCRIPTION_EDIT: 'Editar Suscripciones',
    PERMISSION_EDIT	: 'Editar Permisos',
    INSPECTION_DELETE: 'Eliminar Inspecciones',
    SUBSCRIPTION_GET_ALL: 'Listar todas las Suscripciones',
    SUBSCRIPTION_GET_SHOW: 'Mostrar Suscripciones',
    REPORT_COMPANIES: 'Reportes de Empresas',
    UNITS_MASIVE_UPLOAD: 'Carga masiva de unidades'
  },
  inspections: {
    view: 'Ver inspección',
    deleteTitle: 'Eliminar inspección',
    delMessage: '¿Está seguro que desea eliminar esta inspección',
    viewImg: 'Ver imagen',
    viewImgs: 'Ver imágenes',
    viewCom: 'Ver comentario',
    tireDetails: 'Datos de llanta',
    tireDetailsReadOnly: 'Información capturada desde la aplicación móvil. Solo lectura.',
    folio: 'Folio',
    count: 'Inspecciones realizadas',
    damageInspections: 'Inspecciones con daños',
    detailTruck: 'Datos del trailer',
    type: 'Tipo',
    charge: 'Cargado',
    transit: 'Tránsito',
    barrier: 'Sello de barrera',
    stamp: 'Sello',
    freePests: 'Libre de plaga y/o contaminantes',
    seeSeal: 'Ver sello de y mecanismo de cerradura',
    sealFiles: 'Verificación de sello y documentos',
    security: 'Tirar sello de seguridad',
    flipSeal: 'Torcer y voltear el sello de seguridad',
    input: "Entrada",
    output: "Salida",
    on_route: "En ruta",
    yes: "Si",
    no: "No",
    export: "Exportación",
    import: "Importación",
    empty: "Vacío",
    emptyPremises: "Local vacío",
    loaded: "Local cargado",
    throwing: "Botando",
    outsider: "Foranero",
    slight: "Leve",
    moderate: "Moderado",
    high: "Alto",
    none: "Ninguno",
    totalInspections: "Total de inspecciones",
    inspectedPoints: "Puntos inspeccionados",
    unitsWithHighDamage:'Unidades con daños altos'
  },
  validation: {
    tax: 'Ingrese un RFC válido con homoclave',
    required: 'El elemento es requerido',
    startDate: 'La fecha de inicio es requerida',
    endDate: 'La fecha de fin es requerida',
    minNumberChars: 'Mínimo {number} letras',
    minNumber: 'Mínimo {number} números',
    maxNumberChars: 'Máximo {number} letras',
    maxNumber: 'Máximo {number} números',
    exactNumberChars: 'El elemento debe tener exactamente {number} letras',
    exactNumber: 'El elemento debe tener exactamente {number} números',
    minNumberDigits: 'El elemento debe tener al menos {number} digitos',
    maxNumberDigits: 'El elemento no debe tener más de {number} digitos',
    exactNumberDigits: 'El elemento debe tener exactamente {number} digitos',
    invalidEmail: 'Correo electrónico inválido',
    invalidDecimal: 'Decimal inválido',
    noSpecialChars: 'El elemento no debe tener ningún caracter especial',
    exchange: '2 dígitos y hasta 6 decimales permitidos',
    specificDecimal: '15 dígitos y hasta 3 decimales permitidos',
    fiveDigits: '5 dígitos',
    invalidNumber: 'Número inválido',
    onlyLetters: 'El elemento sólo debe contener letras',
    noSpace: 'El elemento solo debe ser una palabra',
    deleteUserQuestion: '¿Estás seguro de eliminar el usuario <b>{name}</b> con el correo electrónico: <b>{email}</b>?',
    deleteSubscriptionQuestion: '¿Estás seguro de eliminar la suscripción de <b>{company}</b>?',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    success: 'Éxito',
    error: 'Error',
    coordinate: 'Debe contener solo números positivos y negativos',
    nonAllowedCharacters: 'Caracteres no permitidos',
    invalidMonth: 'Mes no válido',
    plate: 'Ingrese un mínimo de {minimo} y un máximo de {maximo} caracteres para las placas y no se aceptan carácteres especiales',
    addData: 'Por favor agregue los datos solicitados en el formulario',
    errorData: 'Error en los datos, por favor verifique la información ingresada'
  },
  dropzone: {
    default: 'Arrastre y suelte archivos aquí para cargarlos.<br> Máximo {size}{unit}',
    fallback: 'El navegador no es compatible, se utilizará la carga simple',
    fileTooBig: 'El archivo es demasiado grande, el archivo tiene un tamaño de {{filesize}} y el límite es {{maxFilesize}}',
    invalidFileType: 'Tipo de archivo no permitido',
    responseError: 'Ocurrió un error al procesar la carga del archivo, código: {{statusCode}}',
    cancelUpload: 'Cancelar carga',
    uploadCanceled: 'Carga cancelada',
    cancelUploadConfirmation: '¿Desea cancelar la carga del archivo?',
    removeFile: 'Quitar archivo',
    removeFileConfirmation: '¿Desea quitar el archivo?',
    maxFilesExceeded: 'Límite de número de archivos excedido',
    uploadMessage: 'Arrastre y suelte o de clic aquí para cargar el logo.<br> Máximo {size}{unit}',
    logoSuccess: 'Logo cargado correctamente',
    fileSuccess: 'Archivo cargado correctamente',
    fileFormat: 'Formatos de archivo permitidos: {formats}',
    credentialOperator: 'Arrastre y suelte aquí la imagen de la credencial del operador en formato JPG o PNG.<br> Máximo {size}{unit}',
    licenseOperator: 'Arrastre y suelte aquí la imagen de la licencia del operador en formato JPG o PNG.<br> Máximo {size}{unit}',
    photoOperator: 'Arrastre y suelte aquí la imagen/foto del operador en formato JPG o PNG.<br> Máximo {size}{unit}',
    addPhotoRequired: 'Por favor agregue las fotos/imágenes solicitadas en el formulario'
  },
  wizard: {
    selectSubscription: 'Selecciona tu suscripción',
    cardInfo: 'Información de la tarjeta',
    next: 'Siguiente',
    back: 'Atras',
    finish: 'Terminar',
    registration: 'Registrarse',
    owner: 'Nombre del titular de la tarjeta',
    card: 'Número de tarjeta',
    year: 'Año de expiración',
    month: 'Mes de expiración',
    code: 'Código de seguridad',
    subscription: 'Suscripción',
    cardTitle: 'Tarjeta',
    wireTransfer: 'Transferencia bancaria',
    paymentMethod: 'Método de pago',
    processInfo: 'Procesando información',
    wait: 'Espere porfavor',
    licence_number: 'Número de licencia',
    accountSuccess: 'Cuenta creada correctamente',
    accountSuccessMsg: 'En breve recibirá un correo electrónico con la confirmación de la creación de su cuenta.',
    thanks: 'Gracias por unirte a Intercambios.',
    downloadOrder: 'Descargar order de compra',
    bankMessage: 'Descarga tu orden de compra y realiza el pago de tu suscripción en alguna de las insituciones autorizadas.',
    msg1: 'Al contratar este plan obtienes 1 año de membresia con los siguientes beneficios:',
    msg2: 'Posterior a la anualidad, nos pondremos en contacto con usted para que siga disfrutando los beneficios de la aplicación',
    Limitado: 'Limitado',
    Ilimitado: 'Ilimitado',
    annual: 'Anual',
    usersLimit: 'Límite de usuarios',
    inspectionsLimit: 'Límite de Inspecciones'
  },
  notification: {
    title: 'Titulo',
    message: 'Mensaje',
    level: 'Nivel de importancia',
    importance: 'Importancia',
    HIGH: 'Alta',
    LOW: 'Baja',
    view: 'Visto',
    yes: 'Si',
    no:' No',
    markView: 'Marcar como visto',
    deleteSelect: 'Eliminar seleccionados',
    delete: 'Eliminar notificación',
    markSelect: 'Marcar seleccionados como vistos',
    delMessage: '¿Está seguro que desea eliminar esta notificación?',
    delMassive: '¿Está seguro que desea eliminar las notificaciones seleccionadas?',
    markMassive: '¿Está seguro que desea marcar como "visto" las notificaciones seleccionadas?'
  },
  reports: {
    filterMessage: 'Realice el filtrado de la búsqueda',
    inspectionUnitTypes: 'Inspecciones y tipo de unidad',
    inspectionReportInspector: 'Inspecciones por inspector',
    inspectionReportInspectorMessage: 'Analiza las inspecciones realizadas por el inspector',
    incidentsInspector: 'Incidencias por inspector',
    incidentsInspectorMessage: 'Analiza incidencias detectadas por inspector',
    incidentsUnitType: 'Incidencias por unidades',
    incidentsUnitTypes: 'Incidencias_por_unidades',
    incidentUnitType: 'Incidencias por unidad',
    incidentUnitTypeMessage: 'Indica unidades con mas incidencias',
    checklistReport: 'Reporte de Checklist',
    checklistReportMessage: 'Consulta resultados de checklist realizados',
    downloadReport: 'Descargar reporte',
    filter: 'Filtrar',
    filterWarning: 'Es necesario seleccionar al menos un filtro para realizar la búsqueda',
    InspectionsByUnitType: 'Reporte_Inspecciones_por_tipo_de_unidad',
    InspectionsByInspector: 'Reporte_Inspecciones_por_inspector',
    IncidentsByInspector: 'Reporte_Incidencias_por_inspector',
    IncidentsByUnit: 'Reporte_Incidencias_por_unidades',
    ChecklistReport: 'Reporte_de_checklist',
    inspectionsByUnitType: 'Inspecciones por tipo de unidad',
    inspectionsByUnitTypeMessage: 'Ver inspecciones agrupadas por tipo',
    incidentsAndDamages: 'Incidencias y daños',
    checklist: 'Checklist',
    inspectionPointsWithDamages: 'Puntos de inspección con daños',
    inspectionPointsWithDamagesDoc: 'Puntos_de_inspección_con_daños',
    inspectionPointsWithDamagesMessage: 'Identifica los puntos de inspección donde se han reportado mas daños',
    operatorsWithDamage: 'Operadores con daños',
    operatorsWithDamages: 'Operadores_con_daños',
    operatorsWithDamageMessage: 'Muestra los operadores vinculados a inspecciones donde se han reportado daño',
    frequencyOfDamagesByUnit: 'Frecuencia de daños por unidad',
    frequencyOfDamagesByUnitMessage: 'Analiza la frecuencia con la que se reportan los daños con cada unidad',
    inspectionDetails: 'Detalle de la inspección',
    inspectionCountByUnit: 'Conteo de inspecciones',
    inspectionCountByUnitMessage: 'Consulta la cantidad de inspecciones realizadas por unidad',
    unitInspections: 'Inspecciones de la unidad',
    inspectionCountByUnitDoc: 'Reporte_Conteo_de_inspecciones_por_unidad',
    tireChangeReport: 'Reporte de cambio de llantas',
    tireChangeReportMessage: 'Consulta los cambios de llantas detectados entre inspecciones',
    tireChangeReportDoc: 'Reporte_Cambio_de_llantas',
    totalInspections: 'Total inspecciones',
    totalChanges: 'Total cambios',
    lastResult: 'Último resultado',
    changesCount: '{count} cambio | {count} cambios',
    noChanges: 'Sin cambios',
    yard: 'Patio',
    previousInspectionDate: 'Fecha inspección previa',
    changes: 'Cambios',
    noPreviousInspection: 'Sin inspección previa',
    incompleteInspection: 'Inspección incompleta',
    missingFieldsCount: 'Inspección incompleta: {count} campo sin capturar | Inspección incompleta: {count} campos sin capturar',
    changesFound: 'Cambios encontrados',
    inspectionPoint: 'Punto de inspección',
    evaluatedField: 'Campo evaluado',
    previousValue: 'Valor anterior',
    currentValue: 'Valor actual',
    showChanges: 'Ver cambios'
  },
  monitoring: {
    plaque: 'Placas',
    numberEconomic: 'No. Económico',
    unit_type: 'Tipo de unidad',
    yard: 'Sitio',
    property: 'Propiedad',
    levelDamage: 'Nivel de daño',
    inactiveDays: 'Días inactivo',
    trasnport_unit: 'Unidad de transporte',
    downloadPhotos: 'Descargar fotos',
    graphic: 'Graficar',
    seeDetailsReport: 'Ver reporte de daños',
    damageGallery: 'Galería de daños',
    question: 'Pregunta',
    low: 'Bajo',
    warning: 'Moderado',
    high: 'Alto',
    year: 'Año',
    selectAll: 'Seleccionar todas las fotos',
    lastInspection: 'Última inspección',
    reportedDamage: 'Daños reportados',
    graphicTitle: 'Evolución de incidencias',
    photographicEvidence: 'Evidencia fotográfica'
  },
  incidents: {
    event: 'Registro de incidencias',
    detail: 'Detalle de incidencia'
  },
  unit: {
    title: 'Unidad',
    rejected: 'Unidades rechazadas',
  }
}